<template>
    <div v-if="showMenu" class="position-fixed popup-menu book flex flex-col" :style="{top:clientY, left:clientX}">
        <div v-for="item in menuData" 
        class="popup-menu-item pointer flex flex-center-cz padding-left-m"   @click="itemClick(item.id)" >{{item.name}}</div>
    </div> 
</template>
   
  <script>
  
  export default {
      name: 'PopupMenu',    
      props: {
          menuData:{},
      },

      data() {
          return {
            showMenu: false,
            clientX:'',
            clientY:'',
          }
      },
  
      methods: {

        show(event) {
            console.log("父组件传过来的event", event);
            let x = event.x; //鼠标点击的x坐标
            let y = event.y; //鼠标点击的y坐标
            let menuWidth = 150;//菜单宽度，这个与.popup-menu样式对应的宽度一致
            let menuHeight = this.menuData.length * 30 + 20; //菜单高度，根据菜单项自动计算的高度

            this.clientX = (parseFloat(x) - 10) + "px";
            this.clientY = (parseFloat(y) + 10) + "px";

            let windowWidth = document.documentElement.clientWidth; // 实时屏幕宽度
            let windowHeight = document.documentElement.clientHeight; // 实时屏幕高度

            if (parseFloat(x) + menuWidth > windowWidth) {
                this.clientX = (parseFloat(windowWidth) - menuWidth - 50)  + "px";
            }
            if (parseFloat(y) + menuHeight > windowHeight) {
                this.clientY = (parseFloat(windowHeight) -menuHeight - 50)  + "px";
            }
            this.showMenu = true;
            event.stopPropagation();//阻止事件冒泡
            document.addEventListener("click", this.closeMenu, false);// 添加关闭事件
        },         
        closeMenu() {
            console.log("销毁监听事件。");
            document.removeEventListener("click", this.closeMenu, false);//销毁关闭事件
            this.showMenu = false;
        },
        itemClick(id) {
            this.$emit('menuClick', id);//传参调用父组件事件，让父组件知道是点击到哪个菜单项
        }

      }
  }
  </script>
  
  <style scoped>
    .popup-menu {
        width: 150px;
        padding: 10px;
        border-radius: 10px;
        background-color:#fff;
        border-style: solid;
        border-width: 1px;
        border-color: rgba(0, 0, 0, .2);
        z-index: 999;    
    }

    .popup-menu-item {
        height: 30px;
    }
    .popup-menu-item:hover {
        border-radius: 5px;
        background: rgba(0, 0, 0, .1);
    }

  </style>
  


// WEBPACK FOOTER //
// src/components/popupMenu/PopupMenu.vue